import { render, staticRenderFns } from "./campagin.vue?vue&type=template&id=41249004&scoped=true"
import script from "./campagin.vue?vue&type=script&lang=js"
export * from "./campagin.vue?vue&type=script&lang=js"
import style0 from "./campagin.vue?vue&type=style&index=0&id=41249004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41249004",
  null
  
)

export default component.exports